var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcGender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11029_63150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7834 0V1.25H17.9001L13.0918 6.05833C11.4334 4.76667 9.21676 4.69167 7.50009 5.675C6.58343 5.14167 5.50009 4.89167 4.36676 5.03333C1.63343 5.38333 -0.308238 7.88333 0.0417618 10.6167C0.325095 12.8833 2.10843 14.6667 4.37509 14.95V16.2417H1.2501V17.4917H4.37509V19.9917H5.62509V17.4917H8.7501V16.2417H5.62509V14.95C6.3001 14.8667 6.9251 14.65 7.4751 14.3333C9.61676 15.5917 12.4084 15.1083 13.9751 13.0917C15.3834 11.2833 15.3834 8.75 13.9751 6.93333L18.7834 2.125V6.24167H20.0334V0H13.7834ZM8.7501 10C8.7501 11.1 8.26676 12.075 7.51676 12.7583C6.76676 12.075 6.28343 11.0917 6.28343 10C6.28343 8.90833 6.76676 7.925 7.51676 7.24167C8.26676 7.925 8.7501 8.90833 8.7501 10ZM5.00009 13.75C2.93343 13.75 1.2501 12.0667 1.2501 10C1.2501 7.925 2.9251 6.25 5.00009 6.25C5.50009 6.25 5.9751 6.35 6.40843 6.53333C6.28343 6.65833 6.16676 6.8 6.0501 6.94167C4.50843 8.93333 4.7001 11.7083 6.38343 13.4833C5.9501 13.6583 5.48343 13.7583 4.99176 13.7583L5.00009 13.75ZM10.0334 13.75C9.52509 13.75 9.04176 13.65 8.60009 13.4667C9.60843 12.4167 10.1584 10.9333 9.95843 9.375C9.81676 8.26667 9.31676 7.29167 8.60009 6.54167C9.04176 6.35833 9.52509 6.25833 10.0334 6.25833C12.1001 6.25833 13.7834 7.93333 13.7834 10.0083C13.7834 12.075 12.1001 13.7583 10.0334 13.7583V13.75Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11029_63150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGender);
export default __webpack_public_path__ + "static/media/ic-gender.e8b396d318e7c97d9e38fb6b6d5556f8.svg";
export { ForwardRef as ReactComponent };